import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { OrganizationService } from "../../../services/rnapi2-service/apis/api";
import { RnCommonId, RnOrganizationsProfileVM } from '../../../services/rnapi2-service/models/models';
import { SelectionService } from "../../../services/selection/selection.service";
import { ToasterService, ToastType } from '@rn-platform/frontend-shared-data-access-toaster';
import { CollectionView, SortDescription } from "@mescius/wijmo";

@Component({
  selector: "detailed-billing-reports",
  templateUrl: "./detailed-billing-reports.component.html",
  styleUrls: ["./detailed-billing-reports.component.scss"],
  standalone: false
})
export class DetailedBillingReportsComponent implements OnInit {
  private readonly selectionService = inject(SelectionService);
  private readonly organizationService = inject(OrganizationService);
  private readonly toasterService = inject(ToasterService);
  private readonly destroyRef = inject(DestroyRef);

  public isLoading: boolean = true;
  public selectedOrg: RnOrganizationsProfileVM = new RnOrganizationsProfileVM();
  private detailedBillingReports: any[];

  collectionView!: CollectionView;

  ngOnInit(): void {
    this.selectionService.SelectedOrgProfile
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (result) => {
          this.selectedOrg = result;
          if (this.selectedOrg === null) return;

          this.initGridAndWatchTableParams();
        },
      );
  }

  private initGridAndWatchTableParams() {
    const rnCommonId: RnCommonId = {
      Id: this.selectedOrg.ID.toString(),
    };

    this.organizationService
      .apiV2OrganizationsGetCurrentDetailedBillingReportInfoListingPost(
        rnCommonId,
      )
      .subscribe((result) => {
        if (result.data?.length) {
          this.detailedBillingReports = result.data;
          this.populateGrid();
        }
      });
  }

  private populateGrid() {
    this.detailedBillingReports.sort((a, b) =>
      a.ReportDate < b.ReportDate ? 1 : -1,
    );

    this.collectionView = new CollectionView(this.detailedBillingReports);
    this.collectionView.sortDescriptions.clear();
    this.collectionView.sortDescriptions.push(new SortDescription("ReportDate", false));
    this.isLoading = false;
  }

  getDetailedBillingReport(reportId, fileDate: string) {
    const rnCommonId: RnCommonId = {
      Id: reportId,
      AffectedOrganizationId: this.selectedOrg.ID,
    };

    this.organizationService
      .apiV2OrganizationsGetDetailedBillingReportContentPost(rnCommonId)
      .subscribe({
        next: (result) => {
          const filename = this.selectedOrg.Name + " " + fileDate + ".xlsx";
          const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

          const linkElement = document.createElement("a");
          try {
            const blob = new Blob([result], { type: contentType });
            const url = window.URL.createObjectURL(blob);

            linkElement.setAttribute("href", url);
            linkElement.setAttribute("download", filename);

            const clickEvent = new MouseEvent("click", {
              view: window,
              bubbles: true,
              cancelable: false,
            });
            linkElement.dispatchEvent(clickEvent);
          } catch (ex) {
            console.log(ex);
          }
        },
        error: (error) => {
          console.error(error);
          const message = 'There was an error in downloading the report. Please contact support for further assistance.';
          const id = 'apphub-detailed-billing-reports-download-error-toast';
          this.toasterService.addToast(ToastType.Error_, message, message, id, id);
        },
      });
  }
}
